import type { DealChecklistRow, DealChecklistRowId } from "@/types/borrower";

/** Labels for Merchant Tasks checklist rows — shared with History step copy. */
export const CHECKLIST_ROW_LABELS: Record<DealChecklistRowId, string> = {
  disclosure: "Sign Pre-Engagement Disclosure",
  main_contract: "Sign Main Contract",
  bank_connection: "Connect Bank Account",
  ach_addendum: "Sign ACH Addendum",
  id_verification: "ID Verification",
};

export function checklistRowLabel(id: DealChecklistRow["id"]): string {
  return id in CHECKLIST_ROW_LABELS ? CHECKLIST_ROW_LABELS[id as DealChecklistRowId] : id;
}

/**
 * Map a merchant-flow step key onto the checklist label staff already see.
 * Steps with no checklist row keep the API label.
 */
const FLOW_STEP_CHECKLIST_LABEL: Record<string, DealChecklistRowId> = {
  disclosure: "disclosure",
  main: "main_contract",
  plaid: "bank_connection",
  voided_check: "bank_connection",
  addendum: "ach_addendum",
  id_after_check: "id_verification",
  id_manual_prim: "id_verification",
};

export function staffFlowStepLabel(step: { key: string; label: string }): string {
  const rowId = FLOW_STEP_CHECKLIST_LABEL[step.key];
  return rowId ? CHECKLIST_ROW_LABELS[rowId] : step.label;
}
